/* eslint-disable */
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions =  {}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
};

export type Query = {
  __typename: 'Query';
  /** Retrieve weblabs and respective treatments for specified weblab entries */
  treatments: Array<WeblabTreatment>;
};


export type QueryTreatmentsArgs = {
  weblabEntries: Array<WeblabEntryInput>;
};

export enum Treatment {
  C = 'C',
  T1 = 'T1',
  T2 = 'T2',
  T3 = 'T3'
}

export type WeblabContext = {
  customerId?: Maybe<Scalars['String']>;
  obfuscatedMarketplaceId: Scalars['String'];
  sessionId: Scalars['String'];
};

export type WeblabEntryInput = {
  weblabContext: WeblabContext;
  weblabName: Scalars['String'];
};

export type WeblabTreatment = {
  __typename: 'WeblabTreatment';
  error?: Maybe<Scalars['String']>;
  treatment: Treatment;
  weblabName: Scalars['String'];
};

export type GetTreatmentsQueryVariables = Exact<{
  weblabEntries: Array<WeblabEntryInput> | WeblabEntryInput;
}>;


export type GetTreatmentsQuery = (
  { __typename: 'Query' }
  & { treatments: Array<(
    { __typename: 'WeblabTreatment' }
    & Pick<WeblabTreatment, 'weblabName' | 'treatment' | 'error'>
  )> }
);


export const GetTreatmentsDocument = gql`
    query GetTreatments($weblabEntries: [WeblabEntryInput!]!) {
  treatments(weblabEntries: $weblabEntries) {
    weblabName
    treatment
    error
  }
}
    `;

/**
 * __useGetTreatmentsQuery__
 *
 * To run a query within a React component, call `useGetTreatmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTreatmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTreatmentsQuery({
 *   variables: {
 *      weblabEntries: // value for 'weblabEntries'
 *   },
 * });
 */
export function useGetTreatmentsQuery(baseOptions: Apollo.QueryHookOptions<GetTreatmentsQuery, GetTreatmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTreatmentsQuery, GetTreatmentsQueryVariables>(GetTreatmentsDocument, options);
      }
export function useGetTreatmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTreatmentsQuery, GetTreatmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTreatmentsQuery, GetTreatmentsQueryVariables>(GetTreatmentsDocument, options);
        }
export type GetTreatmentsQueryHookResult = ReturnType<typeof useGetTreatmentsQuery>;
export type GetTreatmentsLazyQueryHookResult = ReturnType<typeof useGetTreatmentsLazyQuery>;
export type GetTreatmentsQueryResult = Apollo.QueryResult<GetTreatmentsQuery, GetTreatmentsQueryVariables>;